
const API = process.env.REACT_APP_API_URL;

export type AuthRole = "admin" | "partner";

export interface LoginResponse {
  message: string;
  id:string,
  user: string;
  role: AuthRole;
  partnerId?: string;
  name?: string;
}

export interface VerifyResponse {
  message: string;
  role: AuthRole;
  id?:string | null;
  user: string;
  partnerId: string | null;
  name: string | null;
}

export const loginApi = async (email: string, password: string): Promise<LoginResponse> => {
  console.log(process.env);
console.log(process.env.REACT_APP_API);
  // console.log("show api url--->",API); 
  
  const adminRes = await fetch(`${API}/auth/admin/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ email, password }),
  });

  if (adminRes.ok) {
    return adminRes.json();
  }

  const partnerRes = await fetch(`${API}/auth/partner/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ email, password }),
  });

  const data = await partnerRes.json();
  if (!partnerRes.ok) {
    throw new Error(data.message || "Login failed");
  }

  return {
    ...data,
    role: data.role === "publisher" ? "partner" : data.role,
    partnerId: data.partnerId ?? data.publisherId,
  };
};

export const changePasswordApi = async (payload: {
  currentPassword: string;
  newPassword: string;
}): Promise<{ message: string }> => {
  const res = await fetch(`${API}/auth/change-password`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(payload),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to change password");
  return data;
};

export const logoutApi = async (): Promise<void> => {
  await fetch(`${API}/auth/logout`, {
    method: "POST",
    credentials: "include",
  });
};

export const verifySessionApi = async (): Promise<VerifyResponse> => {
  const res = await fetch(`${API}/auth/verify`, { credentials: "include" });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Session invalid");
  return {
    ...data,
    role: data.role === "publisher" ? "partner" : data.role,
    partnerId: data.partnerId ?? data.publisherId ?? null,
  };
};

export const forgotPasswordApi = async (email: string) => {
  const res = await fetch(`${API}/auth/forgot-password`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email }),
  });

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.message || "Failed to send OTP");
  }

  return data;
};

export const verifyOtpApi = async (payload: { email: string; otp: string }) => {
  const res = await fetch(`${API}/auth/verify-otp`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.message || "OTP verification failed");
  }

  return data;
};

export const resetPasswordApi = async (payload: {
  email: string;
  newPassword: string;
}) => {
  const res = await fetch(`${API}/auth/reset-password`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.message || "Password reset failed");
  }

  return data;
};